module.exports = __webpack_public_path__ + "static/media/ShirbitLogo.85b4d5de.png";